import { Routes, Route } from "react-router";
import Home from "./pages/home/Home";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme";
import TermsAndConditions from "./pages/home/term-and-conditions/TermsAndConditions";
import Layout from "./components/layout/Layout";
import Listing from "./pages/listing/Listing";
import Profile from "./pages/profile/Profile";
import ProductDetails from "./pages/product-details/ProductDetails";
import axios from "axios";
import { AuthProvider } from "./hooks/AuthContext";
import { LoadingProvider } from "./hooks/LoadingContext";
import Cart from "./pages/cart/Cart";
import PreCheckout from "./pages/pre-checkout/PreCheckout";
import AddressList from "./pages/pre-checkout/AddressList";
import AddAddress from "./pages/pre-checkout/AddAddress";
import { StateDataProvider } from "./hooks/StateContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosAuth from "./utilities/interceptor";
import { CartProvider } from "./hooks/CartContext";
import Account from "./pages/account/Account";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MyOrders from "./pages/my-orders/MyOrders";
import MobileSearch from "./components/common/MobileSearch";
import MyAddress from "./pages/my-address/MyAddress";
import { AnimatePresence } from "framer-motion";
import AboutUs from "./pages/home/about-us/AboutUs";
import ContactUS from "./pages/home/contact-us/ContactUS";
import RefundPolicy from "./pages/home/refund-policy/RefundPolicy";
import OrderDetails from "./pages/home/order-details/OrderDetails";
import AllFlavoursPage from "./components/home/AllFlavoursPage";

function App() {
  const BASE_URL = import.meta.env.VITE_BASE_URL;
  axios.defaults.baseURL = BASE_URL;
  axiosAuth.defaults.baseURL = BASE_URL;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer position="bottom-right" />
      <div className="app">
        <main className="main-content">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <AuthProvider>
              <LoadingProvider>
                <StateDataProvider>
                  <AnimatePresence mode="wait">
                    <Routes>
                      <Route path="/" element={<Layout />}>
                        <Route path="" index element={<Home />} />
                        <Route path="search" element={<MobileSearch />} />
                        <Route
                          path="listing/:slug/:sortKind?/:flavour?"
                          element={<Listing />}
                        />
                        <Route path="profile" element={<Profile />} />
                        <Route
                          path="product-description/:productName/:id/:varIndex?"
                          element={<ProductDetails />}
                        />
                        <Route
                          path="terms-and-conditions"
                          element={<TermsAndConditions />}
                        />
                        {/* <Route path="customDesign" element={<CakeDesigner/>} /> */}
                        <Route path="about-us" element={<AboutUs />} />
                        <Route path="contact-us" element={<ContactUS />} />
                        <Route
                          path="refund-policy"
                          element={<RefundPolicy />}
                        />
                        <Route
                          path="cart"
                          element={
                            <CartProvider>
                              <Cart />
                            </CartProvider>
                          }
                        />
                        {/* <Route path="custom-support" element={<CustomSupport />} /> */}
                        <Route
                          path="/all-flavours"
                          element={<AllFlavoursPage />}
                        />

                        <Route path="pre-checkout" element={<PreCheckout />}>
                          <Route index element={<AddAddress />} />
                          <Route path="add-address" element={<AddAddress />} />
                          <Route
                            path="list-address"
                            element={<AddressList />}
                          />
                          <Route path="pickup" element={<AddressList />} />
                        </Route>
                        <Route path="account" element={<Account />}>
                          <Route index element={<Profile />} />
                          <Route path="profile" element={<Profile />} />
                          <Route path="my-address" element={<MyAddress />} />
                          <Route
                            path="my-orders"
                            element={
                              <CartProvider>
                                <MyOrders />
                              </CartProvider>
                            }
                          />
                          <Route
                            path="my-orders/:orderId"
                            element={
                              <CartProvider>
                                <OrderDetails />
                              </CartProvider>
                            }
                          />
                        </Route>
                      </Route>
                    </Routes>
                  </AnimatePresence>
                </StateDataProvider>
              </LoadingProvider>
            </AuthProvider>
          </LocalizationProvider>
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;
